<template>
	<div class="set-password-wrapper">
		<!-- <Header url="/my" title="绑定手机" background="#ffffff"></Header> -->
		<div class="login-content">
			<van-form>
				<div class="list">
					<p>手机号</p>
					<van-field v-model="form.mobile" type="text" placeholder="请输入账号"></van-field>
				</div>
				<div class="list">
					<p>验证码</p>
					<van-field
					  v-model="form.captcha"
					  type="text"
					  placeholder="请输入验证码"
					>
					  <template #button>
						<van-button class="get-code" @click="getCaptcha">{{
						  captchaCD > 0 ? captchaCD + "s" : "获取验证码"
						}}</van-button>
					  </template>
					</van-field>
				</div>
				
				<!-- <div class="list">
					<p>登录密码</p>
					<van-field v-model="form.password" type="password" placeholder="请输入登录密码"></van-field>
				</div>
				<div class="list">
					<p>确认密码</p>
					<van-field v-model="password1" type="password" placeholder="请再次输入登录密码"></van-field>
				</div> -->
			</van-form>
			<van-button round @click="onSubmit" class="login-btn">确认</van-button>
			
		</div>
	</div>
</template>

<script>
	// import {request} from "@/api/index";
	export default {
		name: "set-password",
		data() {
			return {
				form: {
					mobile: "",
					captcha: "",
				},
				password1: "",
				pwdType: "password",
				pwdType1: "password",

				captchaCD: 0,
			};
		},
		mounted() {
			this.form.mobile = localStorage.getItem('mobile')
		},
		created() {},
		methods: {
			onSubmit() {
				if (!this.form.mobile) {
					return this.$toast("请输入手机号");
				}

				// if (!this.form.password || !this.password1) {
				// 	return this.$toast("请填写登录密码");
				// }

				if (!this.form.captcha) {
					return this.$toast("请输入验证码");
				}
				// if (!this.$common.isPass(this.form.password)) {
				// 	return this.$toast("登录密码为6-20位字母数字组合");
				// }
				// if (this.form.password !== this.password1) {
				// 	return this.$toast("登录密码输入不一致");
				// }

				let _this = this;
				this.$post({
				  module: "User",
				  interface: "2007",
				  data:this.form,
				}).then((res) => {
					this.$toast.success('绑定成功！')
					setTimeout(function() {
						_this.$router.push({
							path: "/my",
						});
					}, 1000);
				});
				// request({
				// 	module: "mobile",
				// 	interface: "1004",
				// 	data: this.form,
				// }).then((resp) => {
				// 	this.$toast(resp.message);
				// 	setTimeout(function() {
				// 		_this.$router.push({
				// 			path: "/",
				// 			query: {
				// 				mobile: _this.form.mobile,
				// 			},
				// 		});
				// 	}, 2000);
				// });
			},

			// 获取验证码
			getCaptcha() {
				if (this.captchaCD > 0) {
					return false;
				}
				if (!this.form.mobile) {
					return this.$toast("手机号不能为空");
				}
				this.$post({
				  module: "User",
				  interface: "2006",
				  data:{
					  mobile:this.form.mobile
				  }
				}).then((res) => {
					this.$toast(res.message);
					this.captchaCD = 60;
					let timer = setInterval(() => {
						if (this.captchaCD <= 0) {
							clearInterval(timer);
						} else {
							this.captchaCD -= 1;
						}
					}, 1000);
				});

				// 接口
				// request({
				// 	module: "Account",
				// 	interface: "1003",
				// 	data: {
				// 		account: this.form.account
				// 	},
				// }).then((resp) => {
				// 	this.$toast(resp.data.message);
				// 	this.captchaCD = 60;
				// 	let timer = setInterval(() => {
				// 		if (this.captchaCD <= 0) {
				// 			clearInterval(timer);
				// 		} else {
				// 			this.captchaCD -= 1;
				// 		}
				// 	}, 1000);
				// });
			},
		},
	};
</script>
<style lang="less" scoped>

	.set-password-wrapper {
		width: 100%;
		// height: 100vh;
		// background-color: #fff;

		.login-content {
			padding: 40px 20px;
			.list{
				background:#fff;
				background: #FFFFFF;
				box-shadow: 0px 0px 16px 0px rgba(96, 98, 102, 0.08);
				border-radius: 22px;
				padding:10px;
				margin-bottom:10px;
				p{
					padding-left:10px;
					font-size:13px;
					line-height:30px;
				}
			}
			.login-btn {
				margin: 50px auto 0;
				width: 100%;
				height: 50px;
				display: block;
				// box-shadow: 0px 4px 8px 2px #c5ead1;
				// width: 311px;
				// height: 50px;
				// background: linear-gradient(147deg, #14B6FF 0%, #48A7FF 100%);
				background: linear-gradient(219deg, #FD7867 0%, #E02020 100%);
				border-radius: 8px;
				border: none;
				color: #fff;
			}

			.cancel-btn {
				margin: 0 auto;
				width: 80%;
				height: 40px;
				display: block;
				color: #E5232B;
				background: none;
				border: none;
			}

			.title {
				font-size: 36px;
				// font-weight: 600;
				line-height: 70px;
				color: #fff;
			}

			.smallTitle {
				color: #48A7FF;
				font-size: 18px;
				line-height: 50px;
			}

			.van-cell {
				// border: 1px solid #ededee;
				border-radius: 8px;
				height: 48px;
				margin-top: 12px;
			}

			.left-icon {
				width: 24px;
			}

			.line {
				display: inline-block;
				width: 1px;
				height: 20px;
				background-color: #ededee;
				margin: 0 10px;
			}

			.right-icon {
				width: 28px;
				position: absolute;
				right: 0px;
				top: 0px;
			}

			// .get-code {
			//   color: $primaryColor;
			//   border: none;
			// }
			.get-code {
				color: #919398;
				border: none;
				height: 28px;
				border:1px solid #919398;
				// background: linear-gradient(147deg, #14B6FF 0%, #0060FF 100%);
				font-size: 12px;
				border-radius: 6px;
				margin-top: 8px;
			}

			/deep/ .van-field__button {
				position: absolute;
				right: -8px;
				top: -8px;
			}
		}

		/deep/.van-cell {
			// background-color: #171226;
		}

		/deep/.van-cell::after {
			border-bottom: 0;
		}

		/deep/.van-field__control {
			// color: #fff;
		}
	}
</style>
